import MasterTab from 'src/components/Layouts/MasterTab.vue';
import LogPlanner from 'src/views/Pages/Dashboard/Grow/LogPlanner/LogPlanner.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const LogPlannerRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'logplanner',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.log_planner',
          component: LogPlanner,
          meta: {
            prefix_permission: 'grow_logplanner',
          },
        },
      ],
    },
  ],
};

export default LogPlannerRoutes;